// import Example from '@/components/views/Example.vue'
//
// Vue.component('example', Example)
import Vue from 'vue'
import LogIn from '@/components/views/LogIn.vue'
import AlertModal from '@/components/shared/AlertModal.vue'
import Loader from '@/components/shared/Loader.vue'
import Navigation from '@/components/shared/Navigation.vue'
import DatePicker from '@/components/shared/DatePicker.vue'
import DatePickerExport from '@/components/shared/DatePickerExport.vue'
import SingleDatePicker from '@/components/shared/SingleDatePicker.vue'
import QrIcon from '@/components/shared/icons/QrIcon.vue'
import TrainersModal from '@/components/shared/TrainersModal.vue'
import QrModal from '@/components/shared/QrModal.vue'
import AdsPagination from '@/components/shared/AdsPagination.vue'
import CapacityView from '@/components/views/access/CapacityView.vue'
import ConfirmationModal from  '@/components/shared/ConfirmationModal.vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import NewNavigation from '@/components/shared/NewNavigation.vue'



// Icons
import DashboardIcon from '@/components/shared/icons/DashboardIcon.vue'
import OffersIcon from '@/components/shared/icons/OffersIcon.vue'
import RewardsIcon from '@/components/shared/icons/RewardsIcon.vue'
import AccessIcon from '@/components/shared/icons/AccessIcon.vue'
import LocationIcon from '@/components/shared/icons/LocationIcon.vue'
import PersonalTrainerIcon from '@/components/shared/icons/PersonalTrainerIcon.vue'
import MessageIcon from '@/components/shared/icons/MessageIcon.vue'
import NewsIcon from '@/components/shared/icons/NewsIcon.vue'
import EventsIcon from '@/components/shared/icons/EventsIcon.vue'
import ClientConnectionsIcon from '@/components/shared/icons/ClientConnectionsIcon.vue'
import InformationIcon from '@/components/shared/icons/InformationIcon.vue'
import PersonalizeIcon from '@/components/shared/icons/PersonalizeIcon.vue'
import InsideRequestIcon from '@/components/shared/icons/InsideRequestIcon.vue'
import ApiConnectionIcon from '@/components/shared/icons/ApiConnectionIcon.vue'
import UserIcon from '@/components/shared/icons/UserIcon.vue'
import EditIcon from '@/components/shared/icons/EditIcon.vue'
import DeleteIcon from '@/components/shared/icons/DeleteIcon.vue'
import ArrowIcon from '@/components/shared/icons/ArrowIcon.vue'
import FormIcon from '@/components/shared/icons/FormIcon.vue'
import NotificationIcon from '@/components/shared/navigation/Notification.vue'
import SupportFileModal from '@/components/shared/SupportFileModal.vue'
import PaymentsIcon from '@/components/shared/icons/PaymentsIcon.vue'
import DirectoryIcon from '@/components/shared/icons/DirectoryIcon.vue'
import CommunityIcon from '@/components/shared/icons/CommunityIcon.vue'
import ContactUsIcon from '@/components/shared/icons/ContactUsIcon.vue'
import CalendarIcon from '@/components/shared/icons/CalendarIcon.vue'
import UserRolesIcon from '@/components/shared/icons/UserRolesIcon.vue'
import SpacesReservationIcon from '@/components/shared/icons/SpacesReservationIcon.vue'
import OfficialsIcon from '@/components/shared/icons/OfficialsIcon.vue'
import BrigadeMembersIcons from '@/components/shared/icons/BrigadeMembersIcon.vue'
import WasteSortingIcon from '@/components/shared/icons/WasteSortingIcon.vue'
import CensusIcon from '@/components/shared/icons/CensusIcon.vue'
import ProvidersIcon from '@/components/shared/icons/ProvidersIcon.vue'
import HomeIcon from '@/components/shared/icons/HomeIcon.vue'
import AlarmIcon from '@/components/shared/icons/AlarmIcon.vue'
import ParcelsIcon from '@/components/shared/icons/ParcelsIcon.vue'
import LockerIcon from '@/components/shared/icons/LockerIcon.vue'
import LockerModal from '@/components/shared/LockerModal.vue'
import UserPropertyIcon from '@/components/shared/icons/UserPropertyIcon.vue'
import DeviceIcon from '@/components/shared/icons/DeviceIcon.vue'

Vue.component('login', LogIn);
Vue.component('alert-modal', AlertModal);
Vue.component('loader', Loader);
Vue.component('navigation', Navigation);
Vue.component('app-date-picker', DatePicker);
Vue.component('app-date-picker-export', DatePickerExport);
Vue.component('qr-icon', QrIcon);
Vue.component('app-single-date-picker', SingleDatePicker);
Vue.component('trainers-modal', TrainersModal);
Vue.component('qr-modal', QrModal);
Vue.component('ads-pagination', AdsPagination);
Vue.component('capacity-view', CapacityView);
Vue.component('confirm-modal', ConfirmationModal);
Vue.component('vue-qrcode', VueQrcode);
Vue.component('new-navigation', NewNavigation);


Vue.component('dashBoard', DashboardIcon);
Vue.component('offer', OffersIcon);
Vue.component('reward', RewardsIcon);
Vue.component('access', AccessIcon);
Vue.component('user-icon', UserIcon);
Vue.component('location', LocationIcon);
Vue.component('classNav', PersonalTrainerIcon);
Vue.component('message-icon', MessageIcon);
Vue.component('news', NewsIcon);
Vue.component('events', EventsIcon);
Vue.component('internalclientconnection', ClientConnectionsIcon);
Vue.component('clientinformation', InformationIcon);
Vue.component('personalize-icon', PersonalizeIcon);
Vue.component('insiderequest', InsideRequestIcon);
Vue.component('form-icon', FormIcon);
Vue.component('api-connection-icon', ApiConnectionIcon);
Vue.component('edit-icon', EditIcon);
Vue.component('delete-icon', DeleteIcon);
Vue.component('arrow-icon', ArrowIcon);
Vue.component('notification-icon', NotificationIcon);
Vue.component('payments-icon', PaymentsIcon);
Vue.component('directory-icon', DirectoryIcon);
Vue.component('community-icon', CommunityIcon);
Vue.component('contact-us-icon', ContactUsIcon);
Vue.component('calendar-icon', CalendarIcon);
Vue.component('user-roles-icon', UserRolesIcon);
Vue.component('spaces-reservation-icon', SpacesReservationIcon);
Vue.component('officials-icon', OfficialsIcon);
Vue.component('brigade-members-icon', BrigadeMembersIcons);
Vue.component('waste-sorting-icon', WasteSortingIcon);
Vue.component('census-icon', CensusIcon);
Vue.component('providers-icon', ProvidersIcon);
Vue.component('home-icon', HomeIcon);
Vue.component('support-file-modal', SupportFileModal);
Vue.component('alarm-icon', AlarmIcon);
Vue.component('parcels-icon', ParcelsIcon);
Vue.component('locker-icon', LockerIcon);
Vue.component('locker-sublocation-modal', LockerModal);
Vue.component('user-property-icon', UserPropertyIcon);
Vue.component('device-icon', DeviceIcon);



// WEBPACK FOOTER //
// ./src/vue/components.js